import { FC } from 'react';
import Form from '@/components/Form';
import { useNavigate } from 'react-router-dom';
import useAsync from '@/hooks/useAsync';
import { enqueueSnackbar } from 'notistack';

import Link from '@/components/Link';
import { Box } from '@mui/material';
import { requestAuthUserPasswordReset } from '@/services/firebase';
import AuthLayout from '../layouts/Auth.layout';

const ForgotPasswordPage: FC = () => {
  const { loading, error, execute } = useAsync(requestAuthUserPasswordReset);
  const navigate = useNavigate();
  const onSubmit = (values: { email: string }) => {
    execute(values.email).then(() => {
      navigate('/login');
      enqueueSnackbar('Password reset email sent. Please check your inbox.', { variant: 'success' });
    });
  };
  return (
    <AuthLayout goback title="forgotPasswordTitle" description="forgotPasswordDescription">
      <Form
        fields={[{ name: 'email', label: 'Email', type: 'text-field', options: {} }]}
        error={error?.message}
        loading={loading}
        onSubmit={onSubmit}
      />

      <Box sx={{ my: 3, textAlign: 'right' }}>
        <Link to="/login">Sign in</Link>
      </Box>
    </AuthLayout>
  );
};

export default ForgotPasswordPage;
